import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import { useParams } from "react-router-dom";
import PermissionForm from "components/Permissions/form";
import { getAllModules, getPermissionById, selectModules, selectPermission, selectPermissionsStatus, updatePermission } from "redux/slices/permissionsSlice";

const currentAction = "EDIT";
const EditPermission = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectPermissionsStatus);
  const permission = useSelector(selectPermission);
  const modules = useSelector(selectModules);
  const { id } = useParams();
  useEffect(() => {
    if (id && !loading) {
      dispatch(getPermissionById(id));
      dispatch(getAllModules());
    }
  }, [dispatch, id]);

  const onSubmit = async (payload) => {
    await dispatch(updatePermission(id, payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.permissions) : ""
    );
  };
  return (
    <>
      <Navbar />
      <LightLayout doublebar loading={loading || !permission}>
        <PermissionForm
          action={currentAction}
          initialValues={permission}
          onSubmit={onSubmit}
          modules={modules}
        />
      </LightLayout>
    </>
  );
};

export default EditPermission;
